export const WebServerIPAddress = 'alttechweb-server.com';
